var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-browse-condition-edit',{attrs:{"value":_vm.value,"model":_vm.model,"browse":_vm.browse}})
}
var staticRenderFns = []

export { render, staticRenderFns }